import { TrophyOutlined } from '@ant-design/icons';
import { Tooltip, theme as antTheme } from 'antd';

/**
 * A small green medal/award icon shown next to a client's name when that client
 * has at least one ACTIVE subscription. Renders nothing when `active` is
 * false/undefined, so call sites can append it unconditionally right after the
 * name. A built-in leading margin keeps it clear of the name text.
 *
 * `@ant-design/icons` has no literal "medal" glyph, so `TrophyOutlined` (the
 * closest award icon) stands in for it.
 */
export function ActiveSubscriptionBadge({ active, title = 'Abonament activ' }: { active?: boolean; title?: string }) {
  const {
    token: { colorSuccess },
  } = antTheme.useToken();

  if (!active) return null;

  return (
    <Tooltip title={title}>
      <TrophyOutlined aria-label={title} style={{ color: colorSuccess, marginInlineStart: 6 }} />
    </Tooltip>
  );
}
